import { cn } from '@/common/utils/utils'
import { ReactNode } from 'react'

type Props = {
    progress?: ReactNode
    children: ReactNode
    footer: ReactNode
    outerClassName?: string
    scrollClassName?: string
    contentClassName?: string
    maxWidthClassName?: string
}

export function ApplicationFlowShell({
    progress,
    children,
    footer,
    outerClassName,
    scrollClassName,
    contentClassName,
    maxWidthClassName = 'max-w-[600px]',
}: Props) {
    return (
        <div className={cn('w-full h-full flex flex-col justify-center items-center min-h-0', outerClassName)}>
            <div
                className={cn(
                    'w-full flex-1 overflow-auto flex flex-col justify-center items-center gap-12',
                    scrollClassName,
                )}
            >
                <div
                    className={cn(
                        'flex w-full flex-col justify-center items-center gap-6',
                        maxWidthClassName,
                        contentClassName,
                    )}
                >
                    {progress}
                    {children}
                </div>
            </div>
            {footer}
        </div>
    )
}
